import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import {motion} from 'framer-motion';
import '../navBar/nav.css';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ToggleIcon = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={`menu-icon`} onClick={handleClick} >
      <span className={`bar bar1 ${isOpen ? 'open' : 'close'}`}></span>
      <span className={`bar bar2 ${isOpen ? 'open' : 'close'}`}></span>
      <span className={`bar bar3 ${isOpen ? 'open' : 'close'}`}></span>
    </div>
  )
}

function BrandExample() {

  const yScroll = window.scrollY;
  console.log(`yScroll : ${yScroll}`)

  return (
    <Container fluid="md">
      <Navbar
        className=""
        style={{
          border: "white 5px",
          display: "flex",
          justifyContent: "center",
          backdropFilter: "10px",
          backgroundColor: "rgb(67, 54, 74)",
        }}
        fixed="top"
      >
        <Container
          style={{
            border: "white 5px",
          }}
        >
          <Navbar.Brand href="/" className="brandIcon">
            <motion.h1
              style={{
                color: "white",
              }}
              animate={{
                scale: 1,
                x: 0,
              }}
              initial={{
                scale: 0,
              }}
              transition={{
                duration: 1,
              }}
            >
              {" "}
              <StyledLink to={"/"}>DEVELOPER</StyledLink>
            </motion.h1>
          </Navbar.Brand>
          <ToggleIcon />
        </Container>
      </Navbar>
      <br />
    </Container>
  );
}

export default BrandExample;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color:white;
`;